import { getCategoryHomeData } from '@/common/requests/data-fetch'

export const getCategoryMainHomeData = async ({ category = '' }) => {
  return getCategoryHomeData({ category })
}
